export const getTextFileAsString = function(fileName, textCallback)
{ 
	var client = new XMLHttpRequest();
	client.open('GET', globalTextsPath + fileName + "?_=" + new Date().getTime());
	client.onreadystatechange = function() {
	  textCallback(client.responseText);
	}
	client.send();
}


// WEBPACK FOOTER //
// ./js/webpages/webpageTools.jsx